import { Stack, useTheme } from "@mui/material";
import { Outlet } from "react-router";

import { TransportOverviewStateProvider } from "./transportOverviewState";
import { TransportAppearanceProvider, type TransportAppearance } from "./transportAppearance";

/**
 * Front shell of the Transport module.
 * The transport module now has a single overview screen; creation pages are
 * routed from the CTA instead of being exposed through section tabs.
 *
 * The layout owns `TransportOverviewStateProvider` so the overview's UI state
 * (selection, filters, search, pagination, map panel) survives navigation to
 * the leg/circuit edit pages and back.
 */
export const TransportLayout = ({ appearance }: { appearance: TransportAppearance }) => {
    const theme = useTheme();

    return (
        <TransportAppearanceProvider appearance={appearance}>
            <TransportOverviewStateProvider>
                {appearance === "legacy" ?
                    <Stack gap={theme.spacing(3.5)} sx={{ padding: theme.spacing(3, 6) }}>
                        <Outlet />
                    </Stack>
                :   <Outlet />}
            </TransportOverviewStateProvider>
        </TransportAppearanceProvider>
    );
};

export default TransportLayout;
